import React, { useRef } from "react";
import styled from "styled-components";

import UserProfile from "../../Component/Normal/UserProfile";
import CenterLogoImage from "./CenterLogoImage";
import InfoInput from "../../Component/MySettingPageComponent/InfoInput";
import CenterTypeSelect from "../../Component/MySettingPageComponent/CenterTypeSelect";
import OpenTimeInput from "../../Component/MySettingPageComponent/OpenTimeInput";
import UsePaymentSystemButton from "../../Component/MySettingPageComponent/UsePaymentSystemButton";
import CenterIntroTextArea from "../../Component/MySettingPageComponent/CenterIntroTextArea";

import FetchModule from "../../Model/Share/Network/FetchModule";
import LogoView from "../../Component/MySettingPageComponent/LogoView";
import useDragAndDrop from "../../Model/Share/Normal/useDragAndDrop";

import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove, rectSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DefaultLogoPath from '../../image/DefaultLogo.png';
import WhitePencelIcon from '../../image/WhitePencel.svg';
import PictureAddImage from '../../image/PictureAdditionPlus.png';
import PictureView from "./PictureView";

const IMAGE_SIZE = {
  LOGO: 600,
  CENTER: 800
};

const ALLOWED_IMAGE_TYPES = ['jpg', 'png', 'jpeg'];
const MAX_CENTER_PHOTOS = 10;

const isValidImageType = (filetype) => ALLOWED_IMAGE_TYPES.includes(filetype.toLowerCase());

const parseProfiles = (profiles) => {
  if (Array.isArray(profiles)) return profiles;

  if (!profiles) return [];

  return profiles.split(',').filter(p => p !== '');
};

const calculateResizedimensions = (naturalWidth, naturalHeight, standardSize) => {
  let resizeWidth = 0;
  let resizeHeight = 0;

  if (naturalWidth < naturalHeight) {
    resizeWidth = standardSize;
    resizeHeight = (standardSize * naturalHeight) / naturalWidth;
  }
  else if (naturalWidth > naturalHeight) {
    resizeHeight = standardSize;
    resizeWidth = (standardSize * naturalWidth) / naturalHeight;
  }
  else {
    resizeWidth = standardSize;
    resizeHeight = standardSize;
  }

  return { resizeWidth, resizeHeight };
};

// 드래그 가능한 LogoView 래퍼 컴포넌트 //
function SortableLogoView(props) {
  const { id, isClicked, data, index, onClickDeleteButton } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <LogoView isClicked={isClicked} data={data} index={index} onClickDeleteButton={onClickDeleteButton} />
    </div>
  );
}

export default function MyStoreIntroductionBox(props) {
  const {
    isClicked,
    onClickModifyCenterInfo,

    data,
    storeLogo,
    setStoreLogo,
    storeLogoThumbnail,
    setStoreLogoThumbnail,
    storeName,
    setStoreName,
    tel,
    setTel,
    type,
    setType,
    address,
    setAddress,
    openingHour,
    setOpeningHour,
    isUsePaymentSystem,
    setIsUsePaymentSystem,
    storeIntro,
    setStoreIntro,
    onClickSave,

    profiles,
    profileThumbnails,
    setProfiles,
    setData,
    autoSave
  } = props;

  const LogoCanvasRef = useRef();
  const LogoHiddenFileInput = useRef(null);
  const LogoFileInputRef = useRef();

  const CenterCanvasRef = useRef();
  const CenterHiddenFileInput = useRef(null);

  const logoHandleClick = e => {
    LogoHiddenFileInput.current.click();
    LogoFileInputRef.current.style.borderColor = '#FF8B48';
  };

  // 로고 이미지 파일 처리 함수 (공통) //
  const processLogoFile = (file) => {
    if (!file) return;

    const fileName = file.name;
    const pathpoint = fileName.lastIndexOf('.');
    const filepoint = fileName.substring(pathpoint + 1, fileName.length);
    const filetype = filepoint.toLowerCase();

    if (isValidImageType(filetype)) {
      const reader = new FileReader();

      // setLogoImgLocalPath(fileName);

      reader.onloadend = () => {
        const base64 = reader.result;
        const naturalImage = new Image();

        naturalImage.src = reader.result.toString();

        naturalImage.onload = function (e) {
          const naturalWidth = e.target.naturalWidth;
          const naturalHeight = e.target.naturalHeight;

          const { resizeWidth, resizeHeight } = calculateResizedimensions(
            naturalWidth,
            naturalHeight,
            IMAGE_SIZE.LOGO
          );

          const image = new Image();
          const canvas = LogoCanvasRef.current;
          const ctx = canvas?.getContext('2d');

          if (ctx) {
            canvas.width = IMAGE_SIZE.LOGO;
            canvas.height = IMAGE_SIZE.LOGO;

            image.src = base64.toString();

            // 사진 크기 조정후 Canvas에 그리기 //
            image.onload = function () {
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              ctx.drawImage(image, ((IMAGE_SIZE.LOGO - resizeWidth) / 2), ((IMAGE_SIZE.LOGO - resizeHeight) / 2), resizeWidth, resizeHeight);
              setStoreLogo(canvas.toDataURL());
            }
          }
          else {
            console.log("Could not get context");
          }
        }
      };
      reader.readAsDataURL(file);
      // setLogoImgFile(file);
    }
    else {
      alert('.jpeg .jpg .png 파일만 가능합니다!');
    }
  };

  const logoHandleChange = e => {
    if (e.target.files[0]) {
      processLogoFile(e.target.files[0]);
    }
  };

  const logoHandleDrop = (file) => {
    processLogoFile(file);
  };



  const centerHandleClick = e => {
    // if (autoSave()) CenterHiddenFileInput.current.click();
    CenterHiddenFileInput.current.click();
    // FileInputRef.current.style.borderColor = '#FF8B48';
  };

  // 센터 이미지 파일 처리 함수 (공통) //
  const processCenterFile = (file) => {
    if (!file) return;

    const fileName = file.name;
    const pathpoint = fileName.lastIndexOf('.');
    const filepoint = fileName.substring(pathpoint + 1, fileName.length);
    const filetype = filepoint.toLowerCase();

    if (isValidImageType(filetype)) {
      // 정상적인 이미지 확장자 파일인 경우
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64 = reader.result;
        const naturalImage = new Image();
        let profile = '';

        naturalImage.src = reader.result.toString();

        if (base64) {
          naturalImage.onload = function (e) {
            const naturalWidth = e.target.naturalWidth;
            const naturalHeight = e.target.naturalHeight;

            const { resizeWidth, resizeHeight } = calculateResizedimensions(
              naturalWidth,
              naturalHeight,
              IMAGE_SIZE.CENTER
            );

            const image = new Image();
            // 각 파일마다 새로운 캔버스 생성 (공유 캔버스 문제 해결)
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (ctx) {
              canvas.width = IMAGE_SIZE.CENTER;
              canvas.height = IMAGE_SIZE.CENTER;
              canvas.backgroundColor = '#FFFFFF';

              image.src = base64.toString();

              // 사진 크기 조정후 Canvas에 그리기 //
              image.onload = function () {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(image, ((IMAGE_SIZE.CENTER - resizeWidth) / 2), ((IMAGE_SIZE.CENTER - resizeHeight) / 2), resizeWidth, resizeHeight);

                // 크기 조절된 사진 데이터 정리하기 //
                profile = canvas.toDataURL();

                setData(prevData => {
                  const currentProfiles = parseProfiles(prevData.profiles);
                  const currentProfileThumbnails = parseProfiles(prevData.profileThumbnails);

                  return {
                    ...prevData,
                    profiles: [...currentProfiles, profile],
                    profileThumbnails: [...currentProfileThumbnails, profile]
                  };
                });
              }
            }
            else {
              // throw new Error('Could not get context');
              console.log("Could not get context");
            }
          }
        }
      };
      reader.readAsDataURL(file);
      // setCenterImgFile(file);
    }
    else {
      alert('.jpeg .jpg .png 파일만 가능합니다!');
    }
  };

  const centerHandleChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      const newFilesCount = e.target.files.length;
      const currentCount = profiles.length;

      if (currentCount + newFilesCount > MAX_CENTER_PHOTOS) {
        alert(`센터 사진은 최대 ${MAX_CENTER_PHOTOS}장입니다.`);

        return;
      }

      Array.from(e.target.files).forEach(file => {
        processCenterFile(file);
      });
    }
  };

  const centerHandleDrop = (filesOrFile) => {
    const files = Array.isArray(filesOrFile) ? filesOrFile : [filesOrFile];
    const newFilesCount = files.length;
    const currentCount = profiles.length;

    if (currentCount + newFilesCount > MAX_CENTER_PHOTOS) {
      alert(`센터 사진은 최대 ${MAX_CENTER_PHOTOS}장입니다.`);

      return;
    }

    files.forEach(file => processCenterFile(file));
  };

  // 센터 사진 Drag & Drop hook 사용 //
  const { isDragOver: isCenterPictureDragOver, dragHandlers: centerPictureDragHandlers } = useDragAndDrop({
    onFileSelect: centerHandleDrop,

    enableDragDrop: true,
    allowMultiple: true,

    onInvalidFileType: () => {
      alert('.jpeg .jpg .png 파일만 가능합니다!');
    }
  });

  // 순서 변경을 위한 센서 설정 //
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // 8px 이동해야 드래그 시작 (클릭과 구분)
      },
    })
  );

  // 드래그 종료 시 순서 변경 처리 (로컬 상태만 업데이트) //
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = active.id;
      const newIndex = over.id;

      const newProfiles = arrayMove(profiles, oldIndex, newIndex);
      const newProfileThumbnails = arrayMove(profileThumbnails, oldIndex, newIndex);

      const newData = {
        ...data,
        profiles: newProfiles,
        profileThumbnails: newProfileThumbnails
      };
      setData(newData);
    }
  };

  function onClickDeleteButton(index) {
    const newProfiles = profiles.filter((_, i) => i !== index);
    const newProfileThumbnails = profileThumbnails.filter((_, i) => i !== index);

    const newData = {
      ...data,
      profiles: newProfiles,
      profileThumbnails: newProfileThumbnails
    };
    setData(newData);
  }

  return (
    <TopLevelWrapper>
      <TitleWrapper>
        <TitleBox backgroundColor='#FFB800'>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='default'>센터 정보</Text>
        </TitleBox>
        <ModifyButton isClicked={isClicked} onClick={onClickModifyCenterInfo}>
          {!isClicked && <PencelImage src={WhitePencelIcon} />}
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='pointer'>{isClicked ? `저장하기` : `수정하기`}</Text>
        </ModifyButton>
      </TitleWrapper>
      {
        isClicked ?
          <InfoView>
            <InfoWrapper>
              <LayerWrapper>
                <LogoWrapper>
                  {/* <Logo src={storeLogo ? storeLogo : DefaultLogoPath} /> */}
                  <LogoBox>
                    <CenterLogoImage
                      profile={storeLogo}
                      defaultProfile={DefaultLogoPath}
                      enableDragDrop={true}
                      onFileSelect={logoHandleDrop} />
                  </LogoBox>
                  <canvas ref={LogoCanvasRef} style={{ display: 'none' }} />
                  <input
                    type="file"
                    ref={LogoHiddenFileInput}
                    onChange={logoHandleChange}
                    style={{ display: 'none' }} />
                  <UploadButton ref={LogoFileInputRef} onClick={logoHandleClick}>사진 변경</UploadButton>
                </LogoWrapper>
                <TextWrapper>
                  <InputWrapper topMargin={0}>
                    <InfoInput column='상호명' defaultVal={storeName} setVal={setStoreName} width='457' />
                    <InfoInput column='전화번호' defaultVal={tel} setVal={setTel} width='224' />
                    <CenterTypeSelect defaultVal={type} setVal={setType} />
                  </InputWrapper>
                  <InputWrapper topMargin={28}>
                    <InfoInput column='센터 주소' defaultVal={address} setVal={setAddress} width='457' />
                    <OpenTimeInput column='영업시간' defaultVal={openingHour} setVal={setOpeningHour} width='224' />
                    <UsePaymentSystemButton isUsePaymentSystem={isUsePaymentSystem} setIsUsePaymentSystem={setIsUsePaymentSystem} width={240} />
                  </InputWrapper>
                </TextWrapper>
              </LayerWrapper>
            </InfoWrapper>
            <TitleWrapper style={{ marginTop: `24px`, width: '1115px' }}>
              <TitleTextWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>센터 소개</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD' cursor='default'>(최대 250자)</Text>
              </TitleTextWrapper>
            </TitleWrapper>
            <InfoWrapper>
              <TextWrapper style={{ marginTop: `24px` }}>
                <CenterIntroTextArea placeholder='센터 소개글을 입력해주세요' defaultValue={storeIntro} setVal={setStoreIntro} />
              </TextWrapper>
            </InfoWrapper>
            <TitleWrapper style={{ marginTop: `24px`, width: '1115px' }}>
              <TitleTextWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>센터 사진</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD' cursor='default'>(최대 10장)</Text>
              </TitleTextWrapper>
            </TitleWrapper>
            <DivisionLine style={{ marginBottom: '6px' }} />

            <CenterPictureDropZone
              $isDragOver={isCenterPictureDragOver}
              {...centerPictureDragHandlers}>
              <InfoWrapper>
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}>
                  <SortableContext
                    items={profiles.map((_, index) => index)}
                    strategy={rectSortingStrategy}>
                    <LayerWrapper style={{ flexWrap: 'wrap' }}>
                      {
                        profiles.map((data, index) => (
                          <SortableLogoView key={data} id={index} isClicked={isClicked} data={data} index={index} onClickDeleteButton={onClickDeleteButton} />
                        ))
                      }
                      <AdditionBox onClick={centerHandleClick}>
                        <AdditionImage src={PictureAddImage} />
                      </AdditionBox>
                    </LayerWrapper>
                  </SortableContext>
                </DndContext>
                <canvas ref={CenterCanvasRef} style={{ display: 'none' }} />
                <input
                  type="file"
                  ref={CenterHiddenFileInput}
                  onChange={centerHandleChange}
                  multiple
                  accept="image/jpeg,image/png,image/jpg"
                  style={{ display: 'none' }} />
              </InfoWrapper>
            </CenterPictureDropZone>
          </InfoView>
          :
          <InfoView>
            <InfoWrapper>
              <LayerWrapper>
                <LogoBox>
                  <UserProfile profile={storeLogo} defaultProfile={DefaultLogoPath} />
                </LogoBox>
                <TextWrapper>

                  <TitleTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={18} color='#000000'>{storeName}</Text>
                    <UsePaymentWrapper>
                      <UsePaymentBracketText>(</UsePaymentBracketText>
                      <UsePaymentText isUsePaymentSystem={isUsePaymentSystem === 'Yes'}>{isUsePaymentSystem === 'Yes' ? '결제 사용' : '결제 미사용'}</UsePaymentText>
                      <UsePaymentBracketText>)</UsePaymentBracketText>
                    </UsePaymentWrapper>
                  </TitleTextWrapper>

                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#969696'>{address}</Text>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#969696'>{tel}</Text>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#969696'>{openingHour}</Text>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#969696'>{type}</Text>
                </TextWrapper>
              </LayerWrapper>
            </InfoWrapper>
            <TitleWrapper style={{ marginTop: `24px`, width: '1115px' }}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>센터 소개</Text>
            </TitleWrapper>
            <DivisionLine />
            <IntroInfoWrapper>
              <IntroTextWrapper>
                <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959'>{storeIntro}</PreText>
              </IntroTextWrapper>
            </IntroInfoWrapper>
            <TitleWrapper style={{ marginTop: `24px`, width: '1115px' }}>
              <TitleTextWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>센터 사진</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD' cursor='default'>(최대 10장)</Text>
              </TitleTextWrapper>
            </TitleWrapper>
            <DivisionLine />
            <InfoWrapper style={{ width: '1115px' }}>
              {
                profiles.length === 0 ?
                  <LayerWrapper style={{ justifyContent: 'center' }}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#BDBDBD' cursor='default'>업로드된 센터 사진이 없습니다</Text>
                  </LayerWrapper>
                  :
                  <LayerWrapper style={{ flexWrap: 'wrap' }}>
                    {
                      profiles.map((data, index) => (
                        <PictureView
                          key={data}
                          isEdit={isClicked}
                          data={data}
                          index={index}
                          onClickDeleteButton={onClickDeleteButton} />
                      ))
                    }
                  </LayerWrapper>
              }
            </InfoWrapper>
          </InfoView>
      }
    </TopLevelWrapper >
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 30px;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 35px 0px 25px 0px;

  width: 100%;

  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  background-color: #FFFFFF;
`;

const TitleBox = styled.p`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 20px;
  margin: 0 0 0 0;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  background-color: ${props => props.backgroundColor};
`;

const ModifyButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 82px;
  height: 24px;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  
  background-color: ${props => props.isClicked ? `#6DD49E` : `#CBCBCB`};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1135px;
`;

const CenterPictureDropZone = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(100% - 14px);

  padding: 6px 0;

  border: 2px solid ${props => props.$isDragOver ? '#FF8B48' : 'transparent'};
  border-radius: 7px;
  box-sizing: border-box;

  transition: border-color 0.2s ease-in-out;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 20px;

  margin-top: ${props => props.topMargin}px;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const UploadButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 120px;
  height: 32px;

  border-radius: 5px;

  background-color: #33C8FF;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 8px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: ${props => props.topMargin}px;

  width: 995px;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 12px 0px;

  width: 1115px;
  height: 1px;

  border-radius: 1px;
  background-color: #DBDBDB;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;

const PencelImage = styled.img`
  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }
`;

const AdditionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 99px;
  height: 99px;

  border-radius: 5px;
  background-color: #E7E7E7;

  object-fit: cover;

  &:hover {
    cursor: pointer;
  }
`;

const AdditionImage = styled.img`
  width: 64px;
  height: 64px;

  object-fit: cover;
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  white-space: pre-wrap;
`;

const UsePaymentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const UsePaymentBracketText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const UsePaymentText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.isUsePaymentSystem ? `#87C8A6` : `#FF3131`};

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const LogoBox = styled.div`
  width: 111px;
  height: 111px;

  border-radius: 15px;

  object-fit: cover;
  overflow: hidden;
`;

const IntroInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1115px;
`;

const IntroTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  word-break:break-all;
  flex-wrap: wrap;

  // margin-top: 24px;
  // margin-bottom: 28px;

  width: 100%;
`;